



















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { UserProfile } from '../BotUsers/components/Users/types'
import ProfileCard from './components/ProfileCard/ProfileCard.vue'
import UserProfileTabs from './components/ProfileTabs/UserProfileTabs.vue'
import { UserProfileConfig } from './types'

@Component({
  components: {
    ProfileCard,
    UserProfileTabs,
  }
})
export default class Profile extends Vue {
  @Prop() config!: UserProfileConfig

  profile: UserProfile | null = null

  @Watch('config.user_id')
  onConfigUserIdChange() {
    this.getProfile()
  }

  getProfile() {
    this.config.getProfile(this.config.user_id)
      .then((profile) => this.profile = profile)
  }

  created(): void {
    this.getProfile()
  }
}
